<template>
    <div>
        <v-dialog
            v-model="$props.params.editDeviceDialog"
            transition="dialog-bottom-transition"
            max-width="600px"
            @keydown.esc="closeEditDeviceDialog()"
            @click:outside="closeEditDeviceDialog()"
        >
            <v-card>
                <v-form @submit.prevent="processAddEditDeviceName()">
                    <v-toolbar
                        color="primary"
                        dark
                        :class="dialogHeadingClasses()"
                    >
                        <v-icon v-text="icons.mdiPlusCircleOutline" class="mr-3"
                                v-if="$props.params.mode === 'add'"></v-icon>
                        <v-icon v-text="icons.mdiMonitorEdit" class="mr-3" v-else></v-icon>
                        <div v-if="$props.params.mode === 'add'">{{ $gettext('Add Equipment') }}</div>
                        <div v-else-if="$props.params.mode === 'edit'">{{ $gettext('Edit Equipment') }}</div>
                        <v-spacer></v-spacer>
                        <v-icon class="mr-2" @click.native.stop="closeEditDeviceDialog()"
                                v-text="icons.mdiClose"></v-icon>
                        <v-icon @click.native.stop="processAddEditDeviceName()" v-text="icons.mdiContentSave"></v-icon>
                    </v-toolbar>

                    <v-divider></v-divider>

                    <v-card-text class="mt-4">
                        <v-container>

                            <v-row>
                                <v-col cols="12">

                                    <div class="text-h6 mb-8">{{ $gettext('Equipment Details') }}</div>

                                    <v-row>
                                        <v-col>

                                            <v-text-field
                                                required
                                                outlined
                                                :placeholder="$gettext('Equipment Name')"
                                                :label="$gettext('Equipment Name')"
                                                v-model="editDeviceName"
                                                :error-messages="editDeviceNameErrors"
                                                @input="$v.editDeviceName.$touch()"
                                                @blur="$v.editDeviceName.$touch()"
                                                autofocus
                                            ></v-text-field>


                                            <v-text-field
                                                :label="$gettext('Mac Address')"
                                                required
                                                :placeholder="$gettext('Mac Address')"
                                                v-model="mac"
                                                :error-messages="macErrors"
                                                outlined
                                                @input="$v.mac.$touch()"
                                                @blur="$v.mac.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

<!--                                    <div class="text-h6 mb-8">{{ $gettext('Status') }}</div>-->

<!--                                    <v-switch-->
<!--                                        :placeholder="$gettext('Status')"-->
<!--                                        v-model="active"-->
<!--                                        outlined-->
<!--                                        :true-value="1"-->
<!--                                        :false-value="0"-->
<!--                                        :label=" active ? $gettext('Active') : $gettext('Inactive')"-->
<!--                                    ></v-switch>-->

                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions color="secondary">
                        <v-spacer></v-spacer>
                        <v-btn class="primary" @click.native.stop="closeEditDeviceDialog()">
                            {{ $gettext('Close') }}
                        </v-btn>
                        <v-btn class="primary" type="submit">
                            {{ $gettext('Save') }}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
            <snackbar ref="snackbar"></snackbar>
        </v-dialog>

    </div>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import Vue from 'vue'

import Vuelidate from 'vuelidate'
import {minLength, required, requiredIf} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import {mapWritableState} from 'pinia'
import {useUsersStore} from '@/stores/UsersStore'
import {findIndex} from 'lodash'
import {useMdmStore} from '@/stores/MdmStore'

Vue.use(Vuelidate)


export default {
    components: {Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigUsers, MixinVuelidate],
    props: {
        params: {
            required: true,
            type: Object,
        },
    },
    watch: {

        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        editDeviceDialog(newVal) {
            let self = this

            if (newVal) {
                self.editDeviceName = self.$props.params.deviceName
            } else {
                self.resetForm()
            }

        },
        chosenDeviceType(newVal) {

            let self = this

            /*
            let devices = self.users[self.userCategoryParentIndex].value[self.userParentIndex].value.devices
            self.deviceIndex = findIndex(devices, { key: self.$props.params.deviceName })

            if (newVal === 'computer') {

                if (self.deviceIndex > -1 && typeof devices[self.deviceIndex].value.phone !== 'undefined') {
                    self.$delete(devices[self.deviceIndex].value, 'phone')
                }

            } else if (newVal === 'phone') {

                if (self.deviceIndex > -1) {

                    devices[self.deviceIndex].value.phone = phoneDefinition
                }

            } */

        }
    },
    mounted() {

        let self = this

        // FIXME: REMOVE THIS
        console.log('self.$props.params', self.$props.params);

        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        self.editDeviceName = self.$props.params.deviceName
        self.mac = self.$props.params.mac
        // self.active = self.$props.params.active
        // self.chosenDeviceType = 'computer'

        self.userCategoryParentIndex = findIndex(self.users, {key: self.$props.params.userCategoryParent})
        self.userParentIndex = findIndex(self.users[self.userCategoryParentIndex].value, {key: self.$props.params.userParent})

        // FIXME: REMOVE THIS
        console.log('self.userCategoryParentIndex', self.userCategoryParentIndex);
        console.log('self.userParentIndex', self.userParentIndex);
        // FIXME: REMOVE THIS
        console.log('self.users', self.users);

        let devices = self.users[self.userCategoryParentIndex].value[self.userParentIndex].value.devices

        self.deviceIndex = findIndex(devices, {key: self.$props.params.deviceName})

        if (self.deviceIndex > -1 && typeof devices[self.deviceIndex].value.phone !== 'undefined') {

            self.phone = devices[self.deviceIndex].value.phone

            if (self.phone.hasOwnProperty('server') && self.phone.server.length > 0) {
                self.chosenDeviceType = 'phone'
            }

        }

    },
    data() {
        return {

            chosenDeviceType: '',
            editDeviceName: '',
            mac: '',
            // active: '',
            userCategoryParentIndex: -1,
            userParentIndex: -1,
            deviceIndex: -1,
        }
    },

    methods: {

        async processAddEditDeviceName() {

            let self = this
            self.$v.$touch()
            await self.$v.$invalid
            await self.$nextTick()
            await self.$nextTick() // safety net

            setTimeout(() => {

                if (!self.$v.$invalid) {

                    // This manipulation is done on both the sides, client side for while edit manipulation, and the server side performs it for all the devices, it covers the case where the user has not touched the device on the client side but still when saving we do expect the mac address to be in the correct format.
                    let value = {
                        mac: self.mac.replaceAll('-', ':').replaceAll(' ', '').toLowerCase(),
                        // active: self.active,
                    }

                    let valueToUpdate = {
                        key: self.editDeviceName,
                        value
                    }

                    if (self.$props.params.mode === 'edit') {

                        self.configUserProcessUpdateUserChildNode(self.$props.params.userCategoryParent, self.$props.params.userParent, self.$parent.editDeviceNameField, valueToUpdate, 'devices', self.$gettext('Equipment'))

                    } else if (self.$props.params.mode === 'add') {

                        self.configUserAddUserChildNode(self.$props.params.userCategoryParent, self.$props.params.userParent, valueToUpdate, 'devices')

                    }

                    // This fixes the bug where when the device was edited, it was not reflected immediately
                    let temp = JSON.parse(JSON.stringify(this.$parent.userExpansionPanelIndex));
                    this.$parent.userExpansionPanelIndex = null;
                    setTimeout(() => {
                        this.$parent.userExpansionPanelIndex = temp;
                    }, 10);

                    self.closeEditDeviceDialog()

                }

            }, 100)

        },

        closeEditDeviceDialog() {
            let self = this
            // self.$emit('close-edit-device-name-dialog', 'editDeviceDialog')
            self.$parent.closeDialog('addEditDeviceDialog')
        },
        resetForm() {
            let self = this
            self.$v.$reset()
            self.editDeviceName = ''
        },
    },
    computed: {

        ...mapWritableState(useMdmStore, {
            servers: 'servers'
        }),

        ...mapWritableState(useUsersStore, {
            users: 'users'
        }),

        editDeviceNameErrors() {
            const errors = []
            if (!this.$v.editDeviceName.$dirty) return errors
            !this.$v.editDeviceName.required && errors.push(this.$gettext('Equipment name is required'))
            !this.$v.editDeviceName.minLength && errors.push(this.$gettext('Equipment name is too short'))
            !this.$v.editDeviceName.isUnique && errors.push(this.$gettextInterpolate(this.$gettext('We already have a device with this name, for %{userParent} please choose another name.'), {userParent: this.$props.params.userParent}))


            return errors
        },

        macErrors() {
            const errors = []
            if (!this.$v.mac.$dirty) return errors
            !this.$v.mac.required && errors.push(this.$gettext('Mac is required'))
            !this.$v.mac.isUnique && errors.push(this.$gettext('Sorry! It appears we already have this mac address in use'))

            return errors
        },

        phoneServerErrors() {
            const errors = []
            if (!this.$v.phone.server.$dirty) return errors
            !this.$v.phone.server.required && errors.push(this.$gettext('Server is required'))

            return errors
        },

        phoneAccountErrors() {
            const errors = []
            if (!this.$v.phone.account.$dirty) return errors
            !this.$v.phone.account.required && errors.push(this.$gettext('Account is required'))

            return errors
        },

        phonePasswordErrors() {
            const errors = []
            if (!this.$v.phone.password.$dirty) return errors
            !this.$v.phone.password.required && errors.push(this.$gettext('Password is required'))

            return errors
        },

    },
    validations: {
        mac: {
            required,
            async isUnique(value, vm) {
                return await this.vuelidateIsUniqueForTwoLevelNestedCustomColumn(value, this.users, 'devices', 'mac', vm.$props.params.mac)
            }
        },
        editDeviceName: {
            required,
            minLength: minLength(3),
            async isUnique(val, vm) {

                await this.$nextTick() // Just to satisfy async method.
                return this.configUserIsDeviceUniqueForUser(val, this.$props.params.userCategoryParent, this.$props.params.userParent, this.$props.params.mode === 'edit' ? this.$props.params.deviceName : false)

            }
        }
    }

}
</script>
